import styled from "styled-components";

export const StyledCanvas = styled.canvas`
  position: absolute;
  left: 0;
  width: 100%;
  height: 100vh;
`;
